import { Controller } from "@hotwired/stimulus"

/**
 * MenoTool Controller
 * 
 * Handles form validation and step navigation for the MenoTool assessment.
 * 
 * Usage:
 *   <form data-controller="menotool"
 *     data-action="submit->menotool#validateBeforeSubmit">
 *     ...
 *   </form>
 */
export default class extends Controller {
  validateBeforeSubmit(event) {
    const form = event.target
    const requiredFields = form.querySelectorAll('[required], input[type="radio"]:required, input[type="checkbox"]:required')
    let isValid = true

    // Check radio button groups
    const radioGroups = {}
    form.querySelectorAll('input[type="radio"]').forEach(radio => {
      const name = radio.name
      if (!radioGroups[name]) {
        radioGroups[name] = []
      }
      radioGroups[name].push(radio)
    })

    // Validate radio groups (at least one must be selected)
    Object.keys(radioGroups).forEach(groupName => {
      const group = radioGroups[groupName]
      const hasSelection = Array.from(group).some(radio => radio.checked)
      if (!hasSelection && group[0].closest('.form-section')) {
        isValid = false
        group[0].closest('.form-section').classList.add('has-error')
      } else {
        group[0].closest('.form-section')?.classList.remove('has-error')
      }
    })

    // Check required checkboxes
    const requiredCheckboxes = form.querySelectorAll('input[type="checkbox"][required]')
    requiredCheckboxes.forEach(checkbox => {
      if (!checkbox.checked) {
        isValid = false
        checkbox.closest('.form-section')?.classList.add('has-error')
      } else {
        checkbox.closest('.form-section')?.classList.remove('has-error')
      }
    })

    if (!isValid) {
      event.preventDefault()
      const firstError = form.querySelector('.has-error')
      if (firstError) {
        firstError.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      return false
    }

    return true
  }
}

